// assumes temp is in Fahrenheit
export const toCorrectTempUnit = (temp, isCelsius) =>
  isCelsius ? toCelsius(temp) : temp;

export const toCelsius = (fahrenheit) => ((fahrenheit - 32) * 5) / 9;

export const tempUnitLabel = (isCelsius) => (isCelsius ? "ºC" : "ºF");
